<!-- 党员社工办理柱状图 -->
<template>
    <div class="nodataBox" v-if="nodata">暂无数据</div>
    <div :id="'echart3'+index" style="width:100%;height:100%" v-else></div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    inject:['isSmallWidth'],
  props:{
    index:{
      type:null,
      default:0,
    },
    token:{
      type:String,
      default: ''
    }
  },
    data() {
    //这里存放数据
        return {
            nodata:false
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            var url = this.urlobj.getPeopleEvent

            this.$get(url,{},{
              token:this.token || this.$store.state.access_token
            }).then(res => {
                if (res.isSucceed) {
                    let data = res.rows
                    if(data.length==1 && data[0].dycount==0 && data[0].sgcount==0){
                        this.nodata=true
                        return
                    }

                    data.forEach(item => {
                        item.communityName = item.communityName.indexOf('社区')>-1?item.communityName.split('社区')[0]:item.communityName.split('街道')[0]+'街道'
                        item.allCount = item.dycount+item.sgcount
                    });

                   data.sort(this.$util.compare('allCount'))
                   //console.log(returndata)
                   if(data.length>5) data=data.slice(0,5)

                   this.initEcharts({
                       label:data.map(item=>item.communityName),
                        dycount:data.map(item=>item.dycount),
                        sgcount:data.map(item=>item.sgcount)
                   })
                } else {

                }
            }).catch(e => {
                reject(e)
            })
        },
        initEcharts (ecdata) {
          var id = 'echart3'+this.index
            var echart = echarts.init(document.getElementById(id));
            let option={
                tooltip : {
                    trigger: 'item',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
                    }
                },
                color:['#fe7c7e','#5ad0b6'],
                legend: {
                    data:['党员','社工'],
                    textStyle:{    //图例文字的样式
                            color:'#91b1fc',  //文字颜色
                            fontSize:12
                        },
                    itemHeight:10,
                    itemWidth:10,
                },
                grid: {
                    left: 15,
                    right: '4%',
                    bottom: '3%',
                    top:30,
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data:ecdata.label,
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12,
                            formatter: (value=>{
                                return this.$util.autoSplit(value)
                            }),
                        },
                        splitLine:{show: false},//去除网格线
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12
                        },
                        splitLine:{
                            lineStyle:{
                                color:'#283071'
                            }
                        },//去除网格线
                        splitNumber:this.isSmallWidth?3:5
                    }
                ],
                series : [
                    // {
                    //     name:'总数',
                    //     type:'bar',
                    //     data:[350, 350, 350, 350, 350],
                    //     barWidth:18,
                    //     itemStyle:{
                    //         color:"rgba(0,0,0,.5)"
                    //     }
                    // },
                    {
                        name:'党员',
                        type:'bar',
                        data:ecdata.dycount,
                        barWidth:7,
                    },
                    {
                        name:'社工',
                        type:'bar',
                        data:ecdata.sgcount,
                        barWidth:7,
                        barGap:1,
                    },


                ]
            }
            echart.setOption(option)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
    height:100%;
}
</style>
